/**
 * `requestedCapability` 显式调用通道的错误码（K1 迭代，冻结契约见
 * `.scratch/skill-collection/k1-contract.md`）。
 *
 * jerry 对 `POST .../messages/stream` 的 `requestedCapability` 字段做前置校验，
 * 校验失败以 HTTP 422 返回下列三值之一——与 `CHAT_ATTACHMENT_ERROR` 同一模式，
 * 前端据错误码判定这是"能力选择失效"而非其它 422（如外部数据源不可用），从而
 * 给出准确的重试提示，而不是笼统的"请重新选择"。
 */
export const REQUESTED_CAPABILITY_ERROR = {
  /** 能力卡在本租户不存在（可能已被删除）。 */
  NOT_FOUND: "REQUESTED_CAPABILITY_NOT_FOUND",
  /** 能力卡已停用。 */
  INACTIVE: "REQUESTED_CAPABILITY_INACTIVE",
  /** 能力卡不是 skill 类绑定（agent 类走顾问钉选，不走本通道）。 */
  NOT_SKILL: "REQUESTED_CAPABILITY_NOT_SKILL",
} as const;

const REQUESTED_CAPABILITY_ERROR_CODES: Set<string> = new Set(
  Object.values(REQUESTED_CAPABILITY_ERROR),
);

/** 判定一个 422 错误码是否属于本通道的三值之一。 */
export function isRequestedCapabilityError(code: string | undefined): boolean {
  return !!code && REQUESTED_CAPABILITY_ERROR_CODES.has(code);
}

/** 能力选择失效时的兜底提示——后端 message 通常已可读，仅在缺失时使用。 */
export const REQUESTED_CAPABILITY_ERROR_NOTICE =
  "所选能力当前不可用，请重新选择后再发送。";
